import './bootstrap';
import './bootstrap';
import "bootstrap-icons/font/bootstrap-icons.css";

import Alpine from 'alpinejs';

window.Alpine = Alpine;

Alpine.start();
